/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */


{
  // brower title change animtion
  document.addEventListener("DOMContentLoaded", function () {
    const originalTitle = document.title;
    const messages = ["You left this...", "Come back!"];
    let messageIndex = 0;
    let titleInterval;

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        titleInterval = setInterval(() => {
          document.title = messages[messageIndex];
          messageIndex = (messageIndex + 1) % messages.length;
        }, 1000); // change message every 1 second
      } else {
        clearInterval(titleInterval);
        document.title = originalTitle;
      }
    });
  });
}

{
  // People viewing this product random code
  document.addEventListener("DOMContentLoaded", function () {
    const viewerText = document.getElementById("product-viewer-text");
    if (!viewerText) return;

    const maxViewers = parseInt(viewerText.dataset.maxViewers, 10);
    let currentViewers = Math.floor(Math.random() * maxViewers * 0.6) + 1;

    const svgIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="20px" height="20px" viewBox="0 0 32 32" version="1.1" style="vertical-align: middle; margin-right: 5px;">
      <path d="M0 16q0.064 0.128 0.16 0.352t0.48 0.928 0.832 1.344 1.248 1.536 1.664 1.696 2.144 1.568 2.624 1.344 3.136 0.896 3.712 0.352 3.712-0.352 3.168-0.928 2.592-1.312 2.144-1.6 1.664-1.632 1.248-1.6 0.832-1.312 0.48-0.928l0.16-0.352q-0.032-0.128-0.16-0.352t-0.48-0.896-0.832-1.344-1.248-1.568-1.664-1.664-2.144-1.568-2.624-1.344-3.136-0.896-3.712-0.352-3.712 0.352-3.168 0.896-2.592 1.344-2.144 1.568-1.664 1.664-1.248 1.568-0.832 1.344-0.48 0.928zM10.016 16q0-2.464 1.728-4.224t4.256-1.76 4.256 1.76 1.76 4.224-1.76 4.256-4.256 1.76-4.256-1.76-1.728-4.256zM12 16q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848-1.184-2.816-2.816-1.184-2.816 1.184l2.816 2.816h-4z"/>
    </svg>
  `;

    function updateViewers() {
      const change = Math.floor(Math.random() * 5) + 1;
      const direction = Math.random() < 0.5 ? -1 : 1;
      currentViewers = currentViewers + (change * direction);
      if (currentViewers < 1) currentViewers = 1;
      if (currentViewers > maxViewers) currentViewers = maxViewers;
      viewerText.innerHTML = `${svgIcon}${currentViewers} People viewing this product`;
    }

    viewerText.innerHTML = `${svgIcon}${currentViewers} People viewing this product`;
    setInterval(updateViewers, 6000);



    // product page add to cart mobile sticky
    const cartWrapper = document.querySelector(".js-add-to-cart-wrapper");
    const originalOffsetTop = cartWrapper.offsetTop;

    window.addEventListener("scroll", function () {
      if (window.scrollY > originalOffsetTop + 100) {
        cartWrapper.classList.add("fixed-add-to-cart");
      } else {
        cartWrapper.classList.remove("fixed-add-to-cart");
      }
    });

  });
}

{
  // Search Bar Animation
  const input = document.getElementById('animatedPlaceholder');

  const words = ["Ring...", "Necklace...", "Earrings...", "Moissanite...", "Anklets...", "Bracelet...", "Mens...", "Polki...", "Kundan..."];
  const fixedPrefix = "Search for ";

  let currentWord = 0;
  let currentChar = 0;
  let typing = true;

  function typePlaceholder() {
    const word = words[currentWord];
    const fullText = fixedPrefix + word;

    if (typing) {
      input.placeholder = fullText.substring(0, fixedPrefix.length + currentChar++);
      if (currentChar > word.length) {
        typing = false;
        setTimeout(typePlaceholder, 1500); // Wait after full word
      } else {
        setTimeout(typePlaceholder, 100); // Typing speed
      }
    } else {
      input.placeholder = fullText.substring(0, fixedPrefix.length + --currentChar);
      if (currentChar === 0) {
        typing = true;
        currentWord = (currentWord + 1) % words.length;
        setTimeout(typePlaceholder, 500); // Pause before next word
      } else {
        setTimeout(typePlaceholder, 50); // Backspace speed
      }
    }
  }

  typePlaceholder();
}


// function bindThisOneClicks(scope = document) {
//   const buttons = scope.querySelectorAll(".this_one");

//   console.log("this one" + buttons);

//   buttons.forEach(button => {
//     if (button.dataset.bound === "true") return; // Avoid duplicate binding
//     button.dataset.bound = "true";

//     button.addEventListener("click", () => {
//       alert("okay");
//     });
//   });
// }

// // Run on initial page load
// document.addEventListener("DOMContentLoaded", () => {
//   bindThisOneClicks();
// });

// // Run when product recommendations load dynamically
// document.addEventListener("shopify:section:load", (event) => {
//   bindThisOneClicks(event.target);
// });
